export type ToastType = 'success' | 'error' | 'info' | 'warning';

export function toast(message: string, type: ToastType = 'info') {
  window.dispatchEvent(new CustomEvent('mela-toast', { detail: { message, type } }));
}
